var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"overlay",attrs:{"fill-height":"","fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"d-flex justify-center",attrs:{"cols":"12"}},[_c('v-img',{attrs:{"src":require('@/assets/overlays/cmg-rotate-phone-to-portrait.png'),"max-width":"75%","height":"auto","contain":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }